type SubscribeCb = () => void;
type InputMethod = 'mouse' | 'keyboard';

/**
 * Singleton for managing current input method (keyboard or mouse).
 */
class InputMethodTracker {
  // Default is keyboard in case an element is focused programmatically.
  private method: InputMethod = 'keyboard';
  private subscribers: Map<any, SubscribeCb> = new Map();

  constructor() {
    if (typeof window !== 'undefined') {
      window.addEventListener('mousedown', () => this.setMethod('mouse'));
      window.addEventListener('keydown', () => this.setMethod('keyboard'));
      // We need to listen on keyUp, in case a TAB is made from the browser's address-bar,
      // so the keyDown is not fired, only the keyUp.
      window.addEventListener('keyup', () => this.setMethod('keyboard'));
    }
  }

  subscribe = (target: any, callback: SubscribeCb) =>
    this.subscribers.set(target, callback);

  unsubscribe = (target: any) => this.subscribers.delete(target);

  /**
   * Is the current input method `keyboard`. if `false` is means it is `mouse`
   */
  isKeyboard = () => this.method === 'keyboard';

  private setMethod(method: InputMethod) {
    if (method !== this.method) {
      this.method = method;
      this.subscribers.forEach((f) => f());
    }
  }
}

export const inputMethod = new InputMethodTracker();
